import {compose, curry} from 'ramda';

export const mediaInParens = mediaFeature => `(${mediaFeature})`;

export const mediaFeaturePlain = curry(
    (name, value) => `${name}:${value}`
);

export const minWidth = compose(
    mediaInParens,
    mediaFeaturePlain('min-width')
);

export const maxWidth = compose(
    mediaInParens,
    mediaFeaturePlain('max-width')
);
